<div class="app-content vertical-scroll" cdkScrollable>
    <ssg-company-info-table></ssg-company-info-table>
</div>
